import { Col } from "reactstrap";
import { H4 } from "../../../../AbstractElements";
import { AdditiveBorder } from "../../../../Constant";
import { ADDITIVE_DATA } from "../../../../Data/UiKit/HelperClasses";

export const AdditiveBorders = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H4 className="mb-3">{AdditiveBorder}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className="helper-box bg-light border"></div>.border
        </div>
        {ADDITIVE_DATA.map((item, index) => (
          <div className="d-flex align-items-center mb-2 gap-2" key={index}>
            <div className={`helper-box bg-light ${item}`}></div>.{item}
          </div>
        ))}
      </div>
    </Col>
  );
};
